import {register} from '@shopify/theme-sections'
import '../../styles/sections/index-download-tabs.scss'

export default register(`index-download-tabs`, {
  onLoad() {
    const $yearFilter = document.querySelectorAll(`[data-trigger="years"]`)
    const $years = document.querySelectorAll(`[data-year]`)
    const $yearName = document.querySelector(`[data-active-year]`)

    if($yearFilter && $yearFilter.length > 0) {
      $yearFilter.forEach((element, index) => {
        element.addEventListener(`click`, (e) => {
            e.preventDefault()
            const target = element.dataset.target
            const $target = document.querySelector(target)
            const filterId = element.parentNode.dataset.closeParent
            const $filter = document.querySelector(`[data-target="#${filterId}"]`)

            $filter.click()

            $years.forEach(($el) => {
              if($el.classList.contains(`visible`)) {
                $el.classList.remove(`visible`)
                const $id = $el.getAttribute(`id`)
                const selector = document.querySelector(`[data-target="#`+$id+`"]`)
                
                selector.classList.remove(`is-active`)
                
              }
            })

            $yearName.innerHTML = element.innerHTML
            element.classList.add(`is-active`)
            $target.classList.add(`visible`)
        })
      })
    }
    
  },

  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload() {
  },
})
